import { Core, Decorative } from "@faire/design-tokens";
import careers from "@faire/web-api/routes/careers";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import {
  Section,
  SectionHeadline,
} from "@faire/retailer/views/careers/__internal__/common/common";
import {
  StyledCTAButton,
  SignUpButtonContent,
  StyledArrowRight,
} from "@faire/retailer/views/careers/ViewOpeningsButton";

export const LearnMoreSection: React.FC = () => {
  return (
    <Section
      $withHorizontalPadding
      $withVerticalPadding
      $backgroundColor={Decorative.shade.yellow}
      align="center"
    >
      <StyledHeadline color={Core.text.inverse} align="center">
        <StrictLocalMsg
          defaultMessage="Learn more about life at Faire"
          description={{
            text: "Section title for people to learn more about working at Faire",
            img: "https://cdn.faire.com/fastly/d142f2e7c11f999f82964b06d58a24d83bd762c49bf0b59a6fcab3f3cc1ba992.png",
          }}
        />
      </StyledHeadline>
      <Spacer height={{ desktopAndAbove: "5x", mobileAndAbove: "4x" }} />
      <BorderlessButton variant="secondary" linkTo={careers()}>
        <SignUpButtonContent>
          <StrictLocalMsg
            defaultMessage="Learn More"
            description={{
              text: "Link to get more information about some subject",
            }}
          />
          <StyledArrowRight />
        </SignUpButtonContent>
      </BorderlessButton>
    </Section>
  );
};

const BorderlessButton = styled(StyledCTAButton)`
  border: none;
`;

const StyledHeadline = styled(SectionHeadline)`
  width: auto;
  ${responsiveMediaQueries.tabletAndBelow} {
    width: 300px;
  }
`;
